BaseModel = require './base_model.coffee'

class global.FlowRecipient extends BaseModel
  @ATTRIBUTES = {
    id: {}
    last_flow_action_taken: {}
    last_flow_action_taken_state: {}
    human_last_flow_action_taken: {}
    statistics: { default: {} }
    flow_id: {}
    status_updated_at: { type: Date }
    metadata: {}
    soft_bounce_failures_count: {}
  }

  @ASSOCIATIONS = {
    reactivate_automatic_task: -> Task
  }

  @SOFT_BOUNCE_MAX_ATTEMPTS = 3 # this value is a reflect of reev-api/NylasSetting#SOFT_BOUNCE_MAX_ATTEMPTS

  emailOpenStatistics: ->
    return if !@statistics.email_open || @last_flow_action_taken == undefined
    @statistics.email_open[@last_flow_action_taken.toString()]

  humanStatusUpdatedAt: ->
    return '' unless @status_updated_at
    @status_updated_at.format('LTS')

  lastActionTakenStateTooltipText: ->
    return if @last_flow_action_taken_state != 'soft_bounce'
    if @soft_bounce_failures_count == 0 || !@softBounceReason()
      Locales.recipient.soft_bounce['generic']
    else
      Locales.recipient.soft_bounce[@softBounceReason()](@soft_bounce_failures_count, FlowRecipient.SOFT_BOUNCE_MAX_ATTEMPTS)

  softBounceReason: ->
    @metadata?.soft_bounce?.reason



// WEBPACK FOOTER //
// ./src/models/flow_recipient.coffee